const musicLinkUrlPartsEN = {
    "view": {
        "table": {
            "title": "Your music links urlpart list",
            "column": {
                "part": "Part",
                "owner": "Owner",
                "action": "Action"
            },
            "placeholder": {
                "search": "Search..."
            },
            "button": {
                "exportCSV": "Export CSV"
            }
        },
        "message": {
            "success": "Music Link Urlpart has been removed!",
            "error": "Something went wrong! Please refresh page and try again!",
            "noUrlparts": "Currently this feature is only offered to few selected users but the good news is that you will also be able to use it really soon. Keep watching this space!"
        },
        "modal": {
            "delete": {
                "header": "Delete {{mlUrlpart}}?",
                "body": "Are you sure that you want to delete this music-link-urlpart?"
            },
            "canNotDelete": {
                "header": "Can't Delete music-link-urlpart {{mlUrlPart}}",
                "body": "Music-link-urlpart {{mlUrlPart}} can't be deleted as it is already associated with a Music Link."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Sub-User",
                "part": "Part",
                "owner": "Owner",
                "addUrlPart": "Add Url Part",
                "editUrlPart": "Edit Url Part"
            },
            "placeholder": {
                "subUser": "Select Sub-user..."
            },
            "help_text": {
                "subUser": "Note: Only use this dropdown if you want to Add Music Link for any of your Sub-users otherwise leave un-selected."
            },
            "button": {
                "reset": "Reset",
                "submit": "Submit"
            },
            "validation": {
                "part": {
                    "required": "Part is required",
                    "max": "Must be exactly 16 characters"
                }
            },
            "message": {
                "subUserLimit": "This sub-user has consumed the maximum limit of 10 urls parts.",
                "urlPartAlreadyTaken": "This Music Link URL is already taken by your account or another user account. Please try something else."
            }
        },
        "message": {
            "addSuccess": "Music link urlpart has been added!",
            "updateSuccess": "Music link urlpart has been updated!",
            "error": "Something went wrong! Please refresh page and try again!"
        }
    }
};

export default musicLinkUrlPartsEN;